
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;

    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary?.nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      'toggle',
      this.onToggle.bind(this)
    );
  }

  // Default Dawn behavior for other disclosures
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onToggle() {
    if (!this.content) return;

    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetailsToggle.open) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.removeAttribute('open');

    this.summary?.setAttribute(
      'aria-expanded',
      'false'
    );
  }
}

if (!customElements.get('details-disclosure')) {
  customElements.define(
    'details-disclosure',
    DetailsDisclosure
  );
}


// ==========================================
// PB STORE MEGA MENU
// Lightweight click handling
// ==========================================

class HeaderMenu extends DetailsDisclosure {

  static activeMenu = null;

  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    if (this.mainDetailsToggle?.open) {
      HeaderMenu.activeMenu = this;
    }
  }

  disconnectedCallback() {
    if (HeaderMenu.activeMenu === this) {
      HeaderMenu.activeMenu = null;
    }
  }

  // Ignore focus changes from Klaviyo popup
  onFocusOut() {
    // Do nothing.
    // Menu remains open when focus changes.
  }

  close() {
    super.close();

    if (HeaderMenu.activeMenu === this) {
      HeaderMenu.activeMenu = null;
    }

    if (this.header) {
      this.header.preventHide = !!HeaderMenu.activeMenu;
    }
  }

  onToggle() {
    const isOpen = this.mainDetailsToggle?.open;

    this.summary?.setAttribute(
      'aria-expanded',
      String(!!isOpen)
    );

    if (isOpen) {

      // Close the previously opened mega menu
      const previousMenu = HeaderMenu.activeMenu;

      if (previousMenu && previousMenu !== this) {
        previousMenu.close();
      }

      HeaderMenu.activeMenu = this;

    } else if (HeaderMenu.activeMenu === this) {
      HeaderMenu.activeMenu = null;
    }

    if (this.header) {
      this.header.preventHide = !!HeaderMenu.activeMenu;
    }

    // Keep original Dawn header position logic
    if (
      this.header &&
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) === ''
    ) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(
          this.header.getBoundingClientRect().bottom
        )}px`
      );
    }
  }

  // Identify clicks within Klaviyo popup
  static isPopupInteraction(event) {
    const selector = [
      '#klaviyo-onsite-active',
      '.klaviyo-form',
      '.klaviyo-form-container',
      '[class*="kl-private-reset"]',
      '[class*="klaviyo-popup"]',
      '[data-testid*="klaviyo"]',
      '[data-testid="form-container"]',
      '[role="dialog"]'
    ].join(',');

    const path = typeof event.composedPath === 'function'
      ? event.composedPath()
      : [event.target];

    return path.some(node =>
      node instanceof Element &&
      !!node.closest(selector)
    );
  }

  // One global listener for all mega menus
  static handleOutsideClick(event) {
    const menu = HeaderMenu.activeMenu;

    if (!menu?.mainDetailsToggle?.open) return;

    // Clicking inside mega menu: keep open
    if (menu.contains(event.target)) return;

    // Clicking inside discount popup: keep open
    if (HeaderMenu.isPopupInteraction(event)) return;

    // Actual outside click: close menu
    menu.close();
  }
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);

  document.addEventListener(
    'pointerdown',
    HeaderMenu.handleOutsideClick,
    true
  );
}